import {Component, forwardRef, Injector, Input} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {
    AbstractMultiSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-multi-select-edit-control.component";
import {WebTerminalSearchModel} from "../web-terminal-search.model";
import {WebTerminalSearchPageComponent} from "../web-terminal-search-page/web-terminal-search-page.component";
import {WebTerminalEditPageComponent} from "../web-terminal-edit-page/web-terminal-edit-page.component";

const CUSTOM_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => WebTerminalMultiSelectEditControlComponent),
    multi: true
};

@Component({
    selector: "wbo-web-terminal-multi-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/multi-select-edit-control.component.html",
    providers: [
        CUSTOM_VALUE_ACCESSOR,
        provideSearchModel(WebTerminalSearchModel)
    ]
})
export class WebTerminalMultiSelectEditControlComponent extends AbstractMultiSelectEditControlComponent<WebTerminalSearchModel> {
    private _site: string;
    private _excludeAssignedSites: boolean;

    constructor(model: WebTerminalSearchModel, injector: Injector) {
        super(model, injector, "webTerminalId", "webTerminalName");
        this.extendedSearchComponent = WebTerminalSearchPageComponent;
        this.extendedEditComponent = WebTerminalEditPageComponent;
    }

    @Input()
    set site(value: string) {
        if (value !== this._site) {
            this._site = value;
            if (this._site) {
                this.model.filter["site"] = value;
                this.writeValue(undefined);
            } else {
                this.model.filter["site"] = undefined;
            }
            this.model.search().subscribe(() => this.data = this.model.data);
        }
    }

    @Input()
    set excludeAssignedSites(value: boolean) {
        if (value != this._excludeAssignedSites) {
            this._excludeAssignedSites = value;
            if (this._excludeAssignedSites) {
                this.model.filter["excludeAssignedSites"] = this._excludeAssignedSites;
                this.writeValue(undefined);
            } else {
                this.model.filter["excludeAssignedSites"] = undefined;
            }
            this.model.search().subscribe(() => this.data = this.model.data);
        }
    }
}
